<template>
    <div class="scoreData" v-if="!isLoading">
        <div class="scoreData__sell">
            <div class="scoreData__sell--header">
                <div class="scoreData__sell--header-title">Score da Venda</div>
                <div class="scoreData__sell--header-value" :style="{ color: dynamicColor }">{{ riskScore }}</div>
            </div>
            <div class="scoreData__sell--content">
                <NewProgressBar :type="'RiskScore'" :valor="riskScore" />
            </div>
            <div class="scoreData__sell--footer">
                <div class="scoreData__sell--footer-title">
                    Minifraud ID:
                </div>
                <div class="scoreData__sell--footer-value">
                    {{ minifraudId }}
                </div>
            </div>
        </div>
        <div class="actions">
            <div class=" actions__header">
                <div class="actions__header--icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="23" viewBox="0 0 18 23" fill="none">
                        <path
                            d="M7.59185 1.08765C7.49583 1.03029 7.38607 1 7.27422 1C7.16237 1 7.05261 1.03029 6.95658 1.08765C6.87718 1.15056 6.82361 1.24041 6.806 1.34017C6.78839 1.43993 6.80798 1.54269 6.86106 1.62898C8.81462 5.0091 9.22698 9.61517 6.55855 12.1546C5.53287 11.2923 4.71859 10.2062 4.1783 8.9799C3.19189 9.5277 2.37435 10.3352 1.8144 11.3148C1.25445 12.2943 0.973479 13.4085 1.00197 14.5365C1.04235 15.531 1.28122 16.5073 1.70453 17.4081C2.12783 18.3089 2.72702 19.1159 3.46684 19.7817C4.20667 20.4475 5.07217 20.9586 6.01245 21.285C6.95272 21.6113 7.94877 21.7463 8.94199 21.682C14.0544 21.682 16.7069 18.5073 16.8804 14.5365C17.0874 9.77279 13.7057 3.91371 7.59185 1.08765Z"
                            stroke="#3682F3" stroke-width="2" stroke-linecap="round" />
                    </svg>
                </div>
                <div class="actions__header--title">Açōes</div>
            </div>
            <div class="actions__content">
                <div class="actions__content--item" @click="clientDetails">
                    <div class="actions__content--item-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" viewBox="0 0 21 15" fill="none">
                            <path
                                d="M0 7.59568H3.48679C3.6336 7.59399 3.77733 7.5533 3.90323 7.47775C4.02912 7.40222 4.13268 7.29456 4.20326 7.1658L7.06911 1.43409C7.13974 1.29138 7.25235 1.17371 7.39181 1.09687C7.53127 1.02002 7.69089 0.987697 7.84926 1.00421C8.007 1.01488 8.15755 1.0742 8.28016 1.17399C8.40279 1.27381 8.49142 1.40917 8.53389 1.56146L12.0844 13.3751C12.131 13.5355 12.2267 13.677 12.3581 13.7798C12.4896 13.8827 12.65 13.9416 12.8168 13.9483C12.973 13.9432 13.1243 13.8921 13.2517 13.8015C13.3791 13.7109 13.477 13.5848 13.5332 13.4388L15.7144 8.10517C15.7745 7.95555 15.8778 7.82721 16.0111 7.73647C16.1443 7.64574 16.3015 7.59673 16.4628 7.59568H20.6979"
                                stroke="#3682F3" stroke-width="1.7" />
                        </svg>
                    </div>
                    <div class="actions__content--item-text">
                        Detalhes
                    </div>
                </div>
                <div v-if="!showButtons" class="actions__content--item" :class="{ 'disabled': status }" :disabled="status" @click="accept()">
                    <div class="actions__content--item-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                            <path
                                d="M9.75679 20.0518C9.28734 20.0518 8.90679 20.4323 8.90679 20.9018C8.90679 21.3712 9.28734 21.7518 9.75679 21.7518V20.0518ZM12.9411 21.7518C13.4105 21.7518 13.7911 21.3712 13.7911 20.9018C13.7911 20.4323 13.4105 20.0518 12.9411 20.0518V21.7518ZM15.8522 4.45745L15.2512 5.05849L15.2512 5.0585L15.8522 4.45745ZM6.84566 4.45745L6.24463 3.85641L6.24462 3.85641L6.84566 4.45745ZM0.15 8.75325C0.149734 9.2227 0.530077 9.60347 0.999519 9.60373C1.46896 9.604 1.84973 9.22366 1.85 8.75422L0.15 8.75325ZM2.05438 4.39647L2.81056 4.78466L2.81056 4.78465L2.05438 4.39647ZM5.47619 1.6904C5.85749 1.41656 5.9446 0.885463 5.67076 0.504167C5.39691 0.122871 4.86582 0.0357608 4.48452 0.309602L5.47619 1.6904ZM20.8479 8.75418C20.8481 9.22362 21.2289 9.60398 21.6983 9.60374C22.1677 9.60349 22.5481 9.22273 22.5479 8.75329L20.8479 8.75418ZM18.2133 0.309611C17.8321 0.0357629 17.301 0.122863 17.0271 0.504154C16.7533 0.885445 16.8404 1.41654 17.2217 1.69039L18.2133 0.309611ZM9.75679 21.7518H12.9411V20.0518H9.75679V21.7518ZM18.5675 8.96071C18.5675 7.04624 17.807 5.21017 16.4532 3.8564L15.2512 5.0585C16.2861 6.09343 16.8675 7.49708 16.8675 8.96071H18.5675ZM16.4532 3.85641C15.0995 2.50267 13.2634 1.74214 11.3489 1.74214V3.44214C12.8125 3.44214 14.2162 4.02357 15.2512 5.05849L16.4532 3.85641ZM11.3489 1.74214C9.43444 1.74214 7.59838 2.50267 6.24463 3.85641L7.4467 5.05849C8.48164 4.02357 9.88531 3.44214 11.3489 3.44214V1.74214ZM6.24462 3.85641C4.89089 5.21016 4.13036 7.04622 4.13036 8.96071H5.83036C5.83036 7.49709 6.41178 6.09343 7.44671 5.05849L6.24462 3.85641ZM4.13036 8.96071V14.5332H5.83036V8.96071H4.13036ZM4.13036 14.5332C4.13036 14.9412 3.96827 15.3325 3.67982 15.621L4.88191 16.823C5.4892 16.2157 5.83036 15.392 5.83036 14.5332H4.13036ZM3.67982 15.621C3.3914 15.9094 3.00015 16.0714 2.59214 16.0714V17.7714C3.45091 17.7714 4.27459 17.4304 4.88191 16.823L3.67982 15.621ZM2.59214 17.7714H20.1057V16.0714H2.59214V17.7714ZM20.1057 16.0714C19.6977 16.0714 19.3064 15.9094 19.018 15.621L17.8159 16.823C18.4232 17.4304 19.247 17.7714 20.1057 17.7714V16.0714ZM19.018 15.621C18.7296 15.3326 18.5675 14.9412 18.5675 14.5332H16.8675C16.8675 15.392 17.2086 16.2157 17.8159 16.823L19.018 15.621ZM18.5675 14.5332V8.96071H16.8675V14.5332H18.5675ZM1.85 8.75422C1.85078 7.37357 2.18003 6.01292 2.81056 4.78466L1.2982 4.00828C0.544501 5.47647 0.150935 7.10291 0.15 8.75325L1.85 8.75422ZM2.81056 4.78465C3.44109 3.55639 4.35478 2.49578 5.47619 1.6904L4.48452 0.309602C3.14406 1.2723 2.05188 2.5401 1.2982 4.00829L2.81056 4.78465ZM22.5479 8.75329C22.547 7.10292 22.1534 5.47647 21.3997 4.00829L19.8874 4.78465C20.5179 6.01292 20.8471 7.37356 20.8479 8.75418L22.5479 8.75329ZM21.3997 4.00829C20.646 2.54007 19.5537 1.27229 18.2133 0.309611L17.2217 1.69039C18.343 2.49579 19.2568 3.55642 19.8874 4.78465L21.3997 4.00829Z"
                                fill="#3682F3" />
                        </svg>
                    </div>
                    <div class="actions__content--item-text">
                        Alarme Falso
                    </div>
                </div>
                <div v-if="!showButtons" class="actions__content--item" :class="{ 'disabled': status }" :disabled="status" @click="deny()" >
                    <div class="actions__content--item-icon red-bg">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                            <path
                                d="M13.499 8.65728C13.3712 8.29496 13.134 7.98124 12.8204 7.75937C12.5067 7.53751 12.1319 7.41844 11.7477 7.41859H10.31C9.89979 7.41645 9.5034 7.56646 9.19743 7.83964C8.89147 8.11282 8.69766 8.48974 8.6535 8.89753C8.60933 9.30531 8.71794 9.71499 8.95833 10.0473C9.19871 10.3797 9.5538 10.6111 9.95491 10.6968L12.1441 11.1745C12.5934 11.2709 12.991 11.5304 13.2602 11.9029C13.5293 12.2753 13.6509 12.7343 13.6014 13.1912C13.5519 13.6481 13.3349 14.0704 12.9922 14.3766C12.6496 14.6828 12.2056 14.8511 11.7461 14.8491H10.509C9.70017 14.8491 9.01236 14.3317 8.75762 13.6104M11.1283 7.41859V5.56056M11.1283 16.7056V14.8491M3.38414 21.6985V17.7182H7.36449M21.5186 9.44858C21.9413 11.7018 21.6039 14.0316 20.5592 16.0723C19.5146 18.113 17.822 19.749 15.7469 20.7237C13.6719 21.6983 11.332 21.9564 9.09446 21.4574C6.85691 20.9584 4.84838 19.7305 3.38414 17.9665M1.17743 13.257C0.754753 11.0038 1.09221 8.67397 2.13683 6.63328C3.18146 4.59259 4.87411 2.95652 6.94913 1.98187C9.02415 1.00721 11.3641 0.749138 13.6016 1.24816C15.8392 1.74717 17.8477 2.97503 19.3119 4.73902M19.3119 1.00703V4.98739H15.3316"
                                stroke="#FF5F5F" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="actions__content--item-text red-color">
                        Reembolsar
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div v-else class="row justify-content-center p-5">
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
import Money from '@/src/mixins/money'
import NewProgressBar from '@/src/components/common/new-progress-bar.vue'

export default {
    name: 'AnalysisTableSell',
    components: { NewProgressBar },
    mixins: [Money],
    props: {
        data: {
            type: Object,
            required: false
        },
        totalizer: {
            type: Object,
            required: false
        },
        status: {
            type: Boolean,
            default:false,
            required: false
        },
        analysis: {
            type: Object,
            required:false
        }
    },
    computed: {
        isLoading() {
            return this.$store.getters["getLoadingAnalysisSelldata"]
        },
        riskScore(){
            return this.data && this.data.risk_score ? this.data.risk_score : 0;
        },
        minifraudId(){
            return this.data && this.data.risk_body && this.data.risk_body.id ? this.data.risk_body.id : '---';
        },

        showButtons(){
            return this.data.status === 'PENDING' || this.data.status === null
        },

        dynamicColor() {
            if (this.data.risk_score > 80) {
                return '#FC183B';
            } else if (this.data.risk_score > 60) {
                return '#FFA500';
            } else if (this.data.risk_score > 45) {
                return '#FFD700';
            } else if (this.data.risk_score > 25) {
                return '#8EBE23';
            } else {
                return '#28A745';
            }
        }
    },
    methods: {
        accept() {
            if(this.showButtons){
                return
            }
            this.$emit('accept', this.analysis.id);
        },
        deny() {
            if(this.showButtons){
                return
            }
            this.$emit('deny', this.analysis.id);
        },
        clientDetails(){
            this.$emit('clientDetails');
        },
    }
};
</script>

<style scoped lang="scss">
.scoreData {
    width: 100%;
    height: auto;

    &__sell {
        width: 100%;
        height: auto;
        border-radius: 15px;
        border: 1px solid #E5E5E5;

        &--header {
            width: 100%;
            padding: 20px;
            display: flex;

            &-title {
                color: #141414;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                display: flex;
                justify-content: flex-start;
                width: 50%;
            }

            &-value {
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                display: flex;
                justify-content: flex-end;
                width: 50%;
            }
        }

        &--content {
            width: 100%;
            padding: 0px 20px;
        }

        &--footer {
            width: 100%;
            padding: 20px 20px;

            &-title {
                color: #B1B1B1;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }

            &-value {
                color: #B1B1B1;
                font-size: 12px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
            }
        }
    }

    &__seller {
        width: 100%;
        height: auto;
        border-radius: 15px;
        border: 1px solid #E5E5E5;
    }
}

.disabled {
    pointer-events: none; 
    opacity: 0.3; 
    cursor: not-allowed !important;
}

.actions {
    margin-top: 10px;
    width: 100%;
    border: 1px solid #E5E5E5;
    border-radius: 15px;
    padding: 20px 4px;

    &__header {
        padding: 0px 20px;
        display: flex;
        justify-content: flex-start;

        &--icon {
            width: 20.698px;
            height: 20.698px;
            flex-shrink: 0;
        }

        &--title {
            color: #3682F3;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-left: 20px;
        }
    }

    &__content {
        height: auto;
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-around;
        margin: 0;
        list-style: none;

        &--item {
            width: 33%;
            height: auto;
            margin: 20px auto 0px auto;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            display: flex;
            cursor: pointer;

            &-icon {
                display: flex;
                background-color: #3682F31A;
                width: 55px;
                height: 55px;
                border-radius: 50%;
                align-items: center;
                justify-content: center;
            }

            &-text {
                color: #3682F3;
                font-size: 13px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                margin: 10px 0px 0px 0px;
                text-align: center;
                width: 100%;
            }
        }

        // action__content--item-icon
    }
}

.red-bg {
    background: rgba(255, 95, 95, 0.10);
}

.red-color {
    color: #FF5F5F;
}
</style>